<div class="bewp-standard-banner" [ngClass]="variantClass" #wrapperEl>
  <div class="bewp-standard-banner__inner">
    <ng-content></ng-content>
    <div class="bewp-standard-banner__close-container">
      <button
        appHideCollapse
        aria-label="Dismiss notification"
        [containerRef]="wrapperEl"
        (click)="afterClose.emit()"
      >
        <app-icon-close color="#36445e" width="20" height="20"></app-icon-close>
      </button>
    </div>
  </div>
</div>
